<template>
<!--	<qw-form @submit.prevent>-->
		<div v-if="editor"
			 class="editor input-background show-on-print editor-view-root">


			<BubbleMenu
				:tippyOptions="{maxWidth: 600}"
				ref="bubbleMenu"
				pluginKey="linkBubbleMenu"
				:shouldShow="shouldShowLinkMenu"
				:editor="editor">
				<LinkEditBubbleMenu
					v-show="linkMenuIsActive"
					ref="linkBubble"
					:editor="editor"
					@hideMenu="hideLinkBubble"
					@change="showLinkMenu"/>
			</BubbleMenu>


			<EditorFixedMenu
				v-if="isEditable"
				class="hide-on-print"
				@linkClicked="showLinkMenu"
				:editor="editor"/>


			<editor-content
				class="editor__content"
				:editor="editor"/>
			<hr v-if="isEditable && (showDivider || showDividerOnHover)"
				style="padding-bottom: 10px;"
				:class="{'show-on-hover-item': showDividerOnHover, 'qw-border-primary': isFocusedData}"/>



		</div>
<!--	</qw-form>-->
</template>

<script>

import {BubbleMenu, Editor, EditorContent} from '@tiptap/vue-3'
import StarterKit from "@tiptap/starter-kit"
import Underline from "@tiptap/extension-underline"
import Placeholder from "@tiptap/extension-placeholder"
import LinkEditBubbleMenu from "@/core/modules/Notes/view/LinkEditBubbleMenu.vue";

import EditorFixedMenu from "@/core/modules/Notes/view/EditorFixedMenu.vue";
import {createDialogLazy} from "@/utils/helpers-external.js";
let EditorSetLinkDialog = () => import("@/core/modules/Notes/view/EditorSetLinkDialog.vue");
import LinkEx from "@/core/modules/Notes/view/LinkEx.js";
import BaseVModelView from "@/core/components/BaseVModelView.vue";

let editorSetLinkDialog = createDialogLazy(EditorSetLinkDialog)

export default {
	name: "EditorView",
	extends: BaseVModelView,
	inheritAttrs: false,

	components: {
		EditorFixedMenu,
		LinkEditBubbleMenu,
		EditorContent,
		BubbleMenu,
		EditorSetLinkDialog,
	},
	props: {
		isEditable: {type: Boolean, default: true},
		showDivider: {Boolean, default: true},
		showDividerOnHover: {Boolean, default: false},
		placeholder: {String, default: "type here"},
	},


	watch: {
		modelValue: {
			immediate: true,
			handler(newVal, oldVal) {
				//WARNING don't do this. below replaceAll("\n", "<br/>") breaks data consistency and while it may display correctly, the internal "\n" still there and if no changes are made to the content it will lead to inconsistent presentation upstream.
				// this.value = (newVal||"").replaceAll("\n", "<br/>")
				console.log("EditorView: modelValue = ", newVal)
				this.editorChangeExternally = true
				if (this.editor && !this.editorChange) {
					// console.log("EditorView: setContent")
					this.editor.commands.setContent(newVal, true)
					this.$forceUpdate()
				}
				this.editorChangeExternally = false
				this.editorChange = false;
			},
		},
	},

	data() {
		return {
			isFocusedData: false,
			linkUrl: null,
			linkMenuIsActive: false,
			editor: null,
			editorChange: false,
			editorChangeExternally: false,
			forceHideBubbleMenu: false,
		}
	},
	mounted() {

		console.log("this.isEditable = ", this.isEditable)
		console.log("this.value = " + this.value)

		this.editor = new Editor({
			enablePasteRules: false,
			enableInputRules: false,
			extensions: [
				StarterKit,
				Underline,
				// .extend({ inclusive: false })
				LinkEx.configure({
					openOnClick: true,
					clickHandler: this.onLinkClicked.bind(this)
				}),
				Placeholder.configure({
					emptyEditorClass: 'is-editor-empty',
					emptyNodeClass: 'is-empty',
					placeholder: this.placeholder,
					showOnlyWhenEditable: true,
					showOnlyCurrent: true,
				}),
				// History,
				// BubbleMenu.configure({
				// BubbleMenu.configure({
				// 	element: document.querySelector('#LinkMenuBubble'),
				// 	pluginKey: 'linkBubbleMenu',
				// 	shouldShow: ({ editor, view, state, oldState, from, to }) => {
				// 		// only show the bubble menu for images and links
				// 		let res = editor.isActive('link')
				// 		console.log("BubbleMenu: shouldShow = ", res)
				// 		return res
				// 	},
				// })

				// new Document(),
				// new Paragraph(),
				// new Text(),
				// new Blockquote(),
				// new BulletList(),
				// new CodeBlock(),
				// new HardBreak(),
				// new Heading({levels: [1, 2, 3]}),
				// new ListItem(),
				// new OrderedList(),
				// new TodoItem(),
				// new TodoList(),
				// new LinkEx({openOnClick: false}, this.onLinkClicked.bind(this)),
				// new Bold(),
				// new Code(),
				// new Italic(),
				// new Strike(),
				// new Underline(),
				// new History(),
				// new Placeholder({
				// 	emptyEditorClass: 'is-editor-empty',
				// 	emptyNodeClass: 'is-empty',
				// 	emptyNodeText: this.placeholder,
				// 	showOnlyWhenEditable: true,
				// 	showOnlyCurrent: true,
				// }),
			],
			content: this.modelValue,
			onUpdate: this.onContentUpdate,
			editable: this.isEditable,
			onFocus: this.onFocus,
			onBlur: this.onBlur,
			handleDoubleClick: this.handleDoubleClick,
			onTransaction: this.onTransaction,
		})
		console.log("this.editor = ", this.editor)

	},
	methods: {

		insertTextAtCursor(text){
			console.log("EditorView: insertTextAtCursor")
			const transaction = this.editor.state.tr.insertText(text)
			this.editor.view.dispatch(transaction)
		},

		getCursorPosition(){
			return this.editor.state.selection.$anchor.pos
		},
		onTransaction({ state }) {
			setTimeout(() => {
				console.log("state.selection =", this.editor.state.selection)
				if(!this.editor.isActive("link")){
					this.linkMenuIsActive = false
				} else {
					if(this.$refs.linkBubble){
						this.$refs.linkBubble.refreshLink()
					}
				}
			})
		},

		handleDoubleClick(){
			console.log("handleDoubleClick")
		},

		onFocus() {
			this.isFocusedData = true
			this.$emit('focus')

		},
		onBlur() {
			this.isFocusedData = false
			// this.linkMenuIsActive = false //don't remove it here, because this will prevent link popup clicks.
			this.$emit('blur')
		},

		onContentUpdate(content) {

			console.log("onContentUpdate1: ", content)
			if(this.editorChangeExternally){
				return
			}
			this.editorChange = true;
			this.valueData = content.editor.getHTML()
			this.notifyValueChanged()
		},

		shouldShowLinkMenu({ editor, view, state, oldState, from, to }) {
			// only show the bubble menu for images and links
			let res = editor.isActive('link')
			console.log("BubbleMenu: shouldShow = ", res, ", editor = ", editor)
			return true// && !this.forceHideBubbleMenu
		},

		hideLinkBubble(){
			this.linkMenuIsActive = false
		},


		onLinkClicked(link) {
			console.log("onLinkClicked = ", link)
			if(this.isEditable){
				this.linkUrl = link
				this.linkMenuIsActive = true
			} else {
				window.open(link, "_blank")
			}
		},

		async showLinkMenu() {
			console.log("EditorView.showLinkMenu")
			this.hideLinkBubble()
			await editorSetLinkDialog({
				editor: this.editor,
			})

		},
	},
	beforeUnmount() {
		this.editor.destroy()
	},
}
</script>
<style lang="scss">
@import "editor";

.editor-view-root{
	p {
		margin: 0;
	}
}
.editor p.is-editor-empty:first-child::before {
	content: attr(data-placeholder);
	float: left;
	color: #aaa;
	pointer-events: none;
	height: 0;
}

//.editor p.is-editor-empty:first-child::before {
//	content: attr(data-placeholder);
//	float: left;
//	color: #adb5bd;
//	pointer-events: none;
//	height: 0;
//}
</style>
